import React, { useState, useEffect } from 'react';
import { X, Download, Gift } from 'lucide-react'; // Certifique-se de ter lucide-react instalado

const ExitIntent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showMobileBanner, setShowMobileBanner] = useState(false);
  const [formStatus, setFormStatus] = useState('idle'); // idle, loading, success

  const [formData, setFormData] = useState({
    nome: '',
    whatsapp: '',
    email: ''
  });

  // URL do seu arquivo de isca digital (PDF)
  const pdfUrl = "https://portal.halitoblindado.com.br/livro-receitas-halito.pdf";

  useEffect(() => {
    // Lógica Desktop: Mouse saindo por cima
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        // Verifica cookie de sessão para não irritar o usuário
        if (!sessionStorage.getItem('exit_intent_shown')) {
          setIsVisible(true);
          sessionStorage.setItem('exit_intent_shown', 'true');
        }
      }
    };

    // Lógica Mobile: Detectar largura da tela
    const checkMobile = () => {
      if (window.innerWidth < 768) {
        // Mostra o banner após 3 segundos no mobile
        setTimeout(() => setShowMobileBanner(true), 3000);
      } else {
        document.addEventListener('mouseleave', handleMouseLeave);
      }
    };

    checkMobile();

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('loading');

    try {
      // Envia para o PHP na pasta public
      const response = await fetch('/save_lead.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormStatus('success');
      } else {
        // Fallback se o PHP falhar (ex: localhost sem PHP)
        console.warn("PHP não respondeu, simulando sucesso.");
        setFormStatus('success');
      }
    } catch (error) {
      console.error("Erro no envio", error);
      setFormStatus('idle');
    }
  };

  const handleInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      {/* === BANNER MOBILE (Fixo no Topo ou Fundo) === */}
      {showMobileBanner && !isVisible && (
        <div
          onClick={() => setIsVisible(true)}
          className="fixed bottom-0 left-0 w-full bg-blue-600 text-white py-3 px-4 z-50 cursor-pointer shadow-lg animate-bounce-slow flex items-center justify-center gap-3 border-t-2 border-blue-400"
        >
          <Gift className="w-6 h-6 text-yellow-300 animate-pulse" />
          <p className="font-bold text-sm leading-tight text-left">
            Não saia de mãos vazias!<br />
            <span className="text-yellow-300">Baixe gratis o livro Jantar do Beijo</span>
          </p>
        </div>
      )}

      {/* === MODAL (Overlay) === */}
      {isVisible && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4 animate-in fade-in duration-300">

          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden relative transform transition-all scale-100">

            {/* Botão Fechar */}
            <button
              onClick={() => setIsVisible(false)}
              className="absolute top-3 right-3 text-white/80 hover:text-white bg-black/20 hover:bg-black/40 rounded-full p-1 transition z-10"
            >
              <X size={20} />
            </button>

            {/* Cabeçalho Vermelho */}
            <div className="bg-red-600 p-5 text-center relative overflow-hidden">
              <div className="absolute inset-0 bg-red-700/50 skew-y-3 transform -translate-y-1/2"></div>
              <h2 className="relative text-white font-extrabold text-xl md:text-2xl uppercase tracking-wide drop-shadow-md">
                ESPERE! 🎁<br />NÃO VÁ EMBORA ASSIM
              </h2>
            </div>

            {/* Corpo do Modal */}
            <div className="p-6 md:p-8">
              <div className="text-center mb-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 text-orange-600 rounded-full mb-3 shadow-inner">
                  <span className="text-3xl font-serif">Ψ</span>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">
                  Livro de Receitas Grátis
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Baixe o <strong>"O Jantar do Beijo"</strong>. 7 Receitas que blindam o hálito e garantem zero fermentação estomacal.
                </p>
              </div>

              {formStatus === 'success' ? (
                <div className="text-center space-y-4">
                  <div className="bg-green-50 border border-green-200 text-green-700 p-4 rounded-xl">
                    <p className="font-bold text-lg">Cadastro realizado! 🎉</p>
                    <p className="text-sm">Clique no botão abaixo para baixar seu livro.</p>
                  </div>
                  <button
                    onClick={() => window.open(pdfUrl, '_blank')}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 rounded-xl shadow-lg hover:shadow-xl transition transform hover:-translate-y-0.5 flex items-center justify-center gap-2 uppercase text-lg"
                  >
                    <Download size={24} />
                    CLIQUE PARA BAIXAR SEU LIVRO
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-3">
                  <div>
                    <input
                      type="text"
                      name="nome"
                      placeholder="Seu primeiro nome"
                      required
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg px-4 py-3 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                      onChange={handleInput}
                    />
                  </div>
                  <div>
                    <input
                      type="tel"
                      name="whatsapp"
                      placeholder="Seu WhatsApp (com DDD)"
                      required
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg px-4 py-3 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                      onChange={handleInput}
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Seu melhor e-mail"
                      required
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg px-4 py-3 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                      onChange={handleInput}
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-xl shadow-lg hover:shadow-xl transition transform hover:-translate-y-0.5 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {formStatus === 'loading' ? (
                      <span>Salvando...</span>
                    ) : (
                      <>
                        <Download size={20} />
                        QUERO BAIXAR AGORA
                      </>
                    )}
                  </button>

                  <p className="text-center text-[10px] text-slate-400 mt-3 flex items-center justify-center gap-1">
                    <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                    Seus dados estão 100% seguros e livres de spam.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExitIntent;